import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 19a4 4 0 1 1-3.75 5.383 1 1 0 0 1 1.876-.691A2 2 0 1 0 19 21H5a1 1 0 1 1 0-2zM15.813 7.172a2 2 0 0 0-2.687 1.136 1 1 0 1 1-1.877-.691A4 4 0 1 1 15 13H3a1 1 0 1 1 0-2h12a2.003 2.003 0 0 0 1.998-2.127 2 2 0 0 0-1.185-1.701"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.813 11.172a2 2 0 0 0-2.687 1.136 1 1 0 0 1-1.877-.691A4 4 0 1 1 26 17H4a1 1 0 1 1 0-2h22a2.003 2.003 0 0 0 1.998-2.127 2 2 0 0 0-1.185-1.701"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconWind = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWind);
export default Memo;
